/**
 * @name chess-queen
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTAuNjggNS40OTktLjk5NiA0Ljk4MmEuNjUuNjUgMCAwMS0xLjEzMS4yOTVMNS44ODUgNy42NjMiIC8+CiAgPHBhdGggZD0ibTEzLjMyIDUuNS45OTUgNC45OGEuNjUuNjUgMCAwMDEuMTMxLjI5NmwyLjY2OC0zLjExMyIgLz4KICA8cGF0aCBkPSJNMjAuNDI4IDguOTUyIDE3LjUgMTgiIC8+CiAgPHBhdGggZD0iTTQgMjBhMiAyIDAgMDEyLTJoMTJhMiAyIDAgMDEyIDJ2MWExIDEgMCAwMS0xIDFINWExIDEgMCAwMS0xLTF6IiAvPgogIDxwYXRoIGQ9Ik02LjUgMTggMy41NzEgOC45NTIiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSI0IiByPSIyIiAvPgogIDxjaXJjbGUgY3g9IjIwIiBjeT0iNyIgcj0iMiIgLz4KICA8Y2lyY2xlIGN4PSI0IiBjeT0iNyIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/chess-queen
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const ChessQueen: string = `
<svg
  class="lucide lucide-chess-queen"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="m10.68 5.499-.996 4.982a.65.65 0 01-1.131.295L5.885 7.663" />
  <path d="m13.32 5.5.995 4.98a.65.65 0 001.131.296l2.668-3.113" />
  <path d="M20.428 8.952 17.5 18" />
  <path d="M4 20a2 2 0 012-2h12a2 2 0 012 2v1a1 1 0 01-1 1H5a1 1 0 01-1-1z" />
  <path d="M6.5 18 3.571 8.952" />
  <circle cx="12" cy="4" r="2" />
  <circle cx="20" cy="7" r="2" />
  <circle cx="4" cy="7" r="2" />
</svg>
`;

export default ChessQueen;
